<script>
  import { 
    layoutMethods,
    mopMethods,
    mopComputed 
  } from "@/state/helpers";
  import flatPickr from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import { ToggleButton } from 'vue-js-toggle-button'
  import Swal from "sweetalert2";
  import moment from 'moment-timezone';

  /**
   * MOP Scheduler component
   * this.$options.filters.isEmpty("");
   */
  export default {
    page: {
      title: "Schedule MOP Edit"
    },
    components: {
      flatPickr,
      ToggleButton,
    },
    computed: {
        ...mopComputed,
      scheduleStatus: {
        get (){
          const currDate = moment().utc(),
                startDate = moment(this.mopDetailsForm?.mopScheduler[0]?.start_at??null).utc();

          let r = {message:"Waiting",color:"text-disabled"},
            endDate = this.mopDetailsForm?.mopScheduler[0]?.end_at??null;
          if(endDate !=null){
            endDate = moment(this.mopDetailsForm?.mopScheduler[0].end_at).utc();
          }

          if(currDate.isBetween(startDate, endDate) || currDate.isAfter(startDate)){
            r = {message:"Ongoing",color:"text-warning"}
          }
          if(currDate.isAfter(endDate)){
            r = {message:"Done",color:"text-success"}
          }
          // console.log(
          //   ":: scheduleStatus ::",
          //   currDate.format("YYYY-MM-DD HH:mm:ss"),
          //   startDate.format("YYYY-MM-DD HH:mm:ss"),
          //   endDate.format("YYYY-MM-DD HH:mm:ss")
          // );
          return r;
        }
      },
    },
    data() {
      return {
        title: "Schedule MOP Edit",
        scheduleData: {
          minAmountRequired:null,
          selectedRateType:"mdr",
          mdrPercentage:null,
          rebatePercentage:null,
          defaultPercentage:0,
          startDate:null,
          endDate:null,
          haveCapped: 0,
          cappedAmount: null,
          isActive: true,
          reason:null
        },
        rateTypeOptions:[
          {text: 'MDR', value: 'mdr'},
          {text: 'Rate Percentage', value: 'rebate'}
        ],
        unlockReason: [
          "Completed Maintenance",
          "Resolved Bugs/Issue",
          "Resolved Fraud Investigation",
        ],
        lockReason: [
          "Maintenance",
          "Bugs/Issue",
          "Change in Business Strategy",
          "Fraud Investigation"
        ],
        orgStatus:false,
        minDate: "today"
      };
    },
    methods: {
      ...layoutMethods,
      ...mopMethods,
      async triggerMopScheduler(){
        await this.testMopDetailsScheduler()
        .then((res)=>{
            console.log("actionMopDetailsScheduler",res)
        })
        .catch((err)=>{
            console.log("actionMopDetailsScheduler err",err)
        });
      },
      openModal(modal=''){
        this.$bvModal.show(modal);
        this.resetForm();
      },
      closeModal(modal=''){
        this.$bvModal.hide(modal);
      },
      async submitChanges(){
        console.log("scheduleData:",JSON.stringify(this.scheduleData))
        await this.actionMopDetailsScheduler({
          ...this.scheduleData,
          startDate:moment(this.scheduleData.startDate).tz('UTC').format("YYYY-MM-DD HH:mm:ss"),
          endDate : moment(this.scheduleData.endDate).tz('UTC').format("YYYY-MM-DD HH:mm:ss"),
          mopDetailsId: this.mopDetailsForm.methodId,
          module: this.mopDetailsForm.module,
          action: this.mopDetailsForm?.hasSchedule ? "create" : "update"
        })
        .then(async (res)=>{
            console.log("actionMopDetailsScheduler",res);
            await this.getMopModule(this.mopDetailsForm.methodId);
            Swal.fire({
              title: "MOP Setup Successful!",
              text: `MOP Scheduler has been setup.`,
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#804997",
            });
            this.closeModal('bv-modal-mop-setup');

        })
        .catch((err)=>{
            console.log("actionMopDetailsScheduler err",err)
            Swal.fire({
              title: "MOP Setup Failed!",
              text: `Failed to setup MOP Scheduler.`,
              icon: "warning",
              showCancelButton: false,
              confirmButtonColor: "#804997",
            });
        });//*/
      },
      getValidationState({ dirty, validated, valid = null }) {
        return dirty || validated ? valid : null;
      },
      resetForm(){
        console.log(":mopDetailsForm:",JSON.stringify(this.mopDetailsForm))
        if(this.mopDetailsForm?.hasSchedule){
          this.scheduleData.minAmountRequired = this.mopDetailsForm.minAmountRequired
          this.scheduleData.selectedRateType = this.mopDetailsForm.rateType
          this.scheduleData.mdrPercentage = this.mopDetailsForm.mdrPercentage
          this.scheduleData.rebatePercentage = this.mopDetailsForm.rebatePercentage
          this.scheduleData.isActive = this.mopDetailsForm.status == "a" ? true:false;
        }
        else{
          const editData = this.mopDetailsForm?.mopScheduler[0];
          this.scheduleData.minAmountRequired = editData.min_amount_required
          this.scheduleData.selectedRateType = editData.rate_type
          this.scheduleData.mdrPercentage = editData.mdr_percentage
          this.scheduleData.rebatePercentage = editData.rebate_percentage
          this.scheduleData.defaultPercentage = editData.default_rate
          this.scheduleData.isActive = editData.status == "a" ? true:false;
          this.scheduleData.startDate = moment(editData.start_at).format("YYYY-MM-DD HH:mm");
          this.scheduleData.endDate = moment(editData.end_at).format("YYYY-MM-DD HH:mm");
          this.scheduleData.haveCapped = editData.have_capped;
          this.scheduleData.cappedAmount = editData.capped_amount;
          this.scheduleData.reason = editData.reason;
          this.minDate = this.scheduleData.startDate;
        }
        this.orgStatus = this.scheduleData.isActive;
      },
      async deleteMOPSchedule(){
        await this.actionMopDetailsScheduler({
          ...this.scheduleData,
          startDate:moment(this.scheduleData.startDate).tz('UTC').format("YYYY-MM-DD HH:mm:ss"),
          endDate : moment(this.scheduleData.endDate).tz('UTC').format("YYYY-MM-DD HH:mm:ss"),
          module: this.mopDetailsForm.module,
          mopDetailsId: this.mopDetailsForm.methodId,
          action: "delete"
        })
        .then(async (res)=>{
            console.log("actionMopDetailsScheduler",res);
            await this.getMopModule(this.mopDetailsForm.methodId);
            Swal.fire({
              title: "MOP Setup Deleted Successful!",
              text: `MOP Scheduler has been deleted.`,
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#804997",
            });
            this.closeModal('bv-modal-mop-setup');

        })
        .catch((err)=>{
            console.log("actionMopDetailsScheduler err",err)
            Swal.fire({
              title: "MOP Setup Delete Failed!",
              text: `Failed to deleted MOP Scheduler.`,
              icon: "warning",
              showCancelButton: false,
              confirmButtonColor: "#804997",
            });
        });//*/
      }
    },
    async mounted(){
      setTimeout(() => {
        this.resetForm();
      }, 1000);
    }
  }
    
</script>

<template>
  <div><!-- outer div-->
    <b-button variant="link" @click="openModal('bv-modal-mop-setup')" class="float-end">
        <span v-if="mopDetailsForm?.hasSchedule">Set Scheduler</span>
        <span v-else>Edit Scheduler</span>
    </b-button>
    <b-button variant="link" @click="deleteMOPSchedule()" class="float-end" v-if="!mopDetailsForm?.hasSchedule">
      Delete Scheduler
    </b-button>
    <p class="fw-bold">{{ title }}</p>
    <template v-for="(m, index) in mopDetailsForm?.mopScheduler">
      <template>
        <div v-bind:key="index">
          <b-card class="w-100">
            <b-card-body class="p-2">
              <b-row>
                <b-col sm="6">
                  <span class="fw-semibold">Rate Type:</span> {{ m.rate_type }}
                </b-col>
                <b-col sm="6">
                  <span class="fw-semibold">Min Amount Required:</span>  ₱ {{m.min_amount_required | numberWithCommas}}
                </b-col>
                <b-col sm="12">
                  <span v-if="m.rate_type == 'rebate'"><span class="fw-semibold">Additional Rebate Percentage:</span> {{ m.rebate_percentage }}%</span>
                  <span v-else><span class="fw-semibold">Percentage Charged to User:</span> {{ m.mdr_percentage }}%</span>
                </b-col>
                <b-col sm="6">
                  <span class="fw-semibold">Status:</span> {{ m.status=="a" ? "Active" : "Inactive" }}
                </b-col>
                <b-col sm="6">
                  <span class="fw-semibold">Schedule Status:</span>  <span :class="scheduleStatus.color">{{ scheduleStatus.message }}</span>
                </b-col>
              </b-row>
            </b-card-body>
            <b-card-footer class="p-2">
              <b-row>
                <b-col sm="6">
                  <i class="bx bx-calendar text-primary"></i> Start Date: <br>{{ m.start_at | formatDate }}
                </b-col>
                <b-col sm="6">
                  - End Date: <br>{{ m.end_at | formatDate }}
                </b-col>
              </b-row> 
            </b-card-footer>
          </b-card>
        </div>
      </template>
    </template>

    <!-- {{mopDetailsForm}} <br><br>{{ scheduleData }} -->

    <b-modal id="bv-modal-mop-setup"
      centered
      hide-header
      hide-footer
      hide-header-close
    >

      <ValidationObserver v-slot="{ handleSubmit, reset }">
        <b-form @submit.prevent="handleSubmit(submitChanges)" @reset.prevent="reset">
          <b-row>
            <b-col sm="12" class="mb-3 border-bottom">
              <h5 class="fw-semibold">MOP Setup Schedule</h5>
            </b-col>
            <b-col sm="12" class="mb-2"><!--isActive-->
              <label class="form-label small fw-bold me-2"
                >Active</label
              >
              <toggle-button
                class="m-0 me-2"
                v-model="scheduleData.isActive"
                color="#e73092"
                :sync="true"
              />
            </b-col><!--isActive-->
            <b-col sm="12" class="mb-3"><!--min amount required-->
              <validation-provider name="Min amount" :rules="{required:false,min_value:0}" v-slot="validationContext">
                <label class="form-label small fw-bold"
                  >Min Amount Required</label
                >
                <div class="input-group">
                  <div class="input-group-text">₱</div>
                  <b-form-input
                    type="number"
                    class="form-control"
                    v-model="scheduleData.minAmountRequired"
                    placeholder="0"
                    :state="getValidationState(validationContext)"
                  />
                </div>
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-col><!--min amount required-->

            <b-col sm="12" class="mb-3"><!--rate type-->
              <validation-provider name="Rate Type" rules="required" v-slot="validationContext">
                <label>Rate Type<span class="text-danger">*</span></label>
                <b-form-group>
                  <b-form-select class="form-select rounded-0 rounded-start rounded-end shadow-none custom-select w-100" style="width:160px"
                    id="change-type"
                    v-model="scheduleData.selectedRateType"
                    :options="rateTypeOptions"
                    :state="getValidationState(validationContext)"
                  ></b-form-select>
                </b-form-group>
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-col><!--rate type-->

            <b-col sm="12" class="mb-3" v-if="scheduleData.selectedRateType == 'rebate'"><!--rebate percentage-->
              <validation-provider name="Rebate" :rules="{required:true,min_value:0}" v-slot="validationContext">
                <label>Additional Rebate Percentage<span class="text-danger">*</span></label>
                <div class="input-group">
                  <div class="input-group-text">%</div>
                  <b-form-input
                    type="number"
                    step="0.01"
                    class="form-control"
                    v-model="scheduleData.rebatePercentage"
                    placeholder="0"
                    :state="getValidationState(validationContext)"
                  />
                </div>
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-col><!--rebate percentage-->

            <b-col sm="12" class="mb-3" v-if="scheduleData.selectedRateType == 'mdr'"><!--mdr percentage-->
              <validation-provider name="MDR" :rules="{required:true,min_value:0}" v-slot="validationContext">
                <label>Percentage Charged to User<span class="text-danger">*</span></label>
                <div class="input-group">
                  <div class="input-group-text">%</div>
                  <b-form-input
                    type="number"
                    class="form-control"
                    v-model="scheduleData.mdrPercentage"
                    placeholder="0"
                    :state="getValidationState(validationContext)"
                  />
                </div>
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-col><!--mdr percentage-->

            <b-col sm="6" class="mb-3"><!--start date-->
              <validation-provider name="Start date" rules="required" v-slot="validationContext">
                  <label>
                    <i 
                      class="fa fa-info-circle mx-" 
                      aria-hidden="true" 
                      v-b-tooltip.hover 
                      title="When the start date is earlier than the current date, it will be replaced with the current date."
                      >
                    </i>
                    Start Date
                    <span class="text-danger">*</span>
                  </label>
                  <input type="hidden" :state="getValidationState(validationContext)" v-model="scheduleData.startDate" class="form-control"/>
                  <flat-pickr
                        :class="{'is-invalid': getValidationState(validationContext) === false}"
                        v-model="scheduleData.startDate"
                        placeholder="Select Start Date"
                        class="form-control ps-2 rounded-end"
                        :config="{
                          minDate   : minDate,
                          enableTime: true,
                          maxDate   : scheduleData.endDate == null ? null:scheduleData.endDate
                        }"
                  ></flat-pickr>
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
              </validation-provider>
            </b-col><!--start date-->

            <b-col sm="6" class="mb-3"><!--end date-->
              <validation-provider name="End date" v-slot="validationContext">
                  <label>End Date<span class="text-danger">*</span></label>
                  <input type="hidden" :state="getValidationState(validationContext)" v-model="scheduleData.endDate" class="form-control"/>
                  <flat-pickr
                        :class="{'is-invalid': getValidationState(validationContext) === false}"
                        v-model="scheduleData.endDate"
                        placeholder="Select End Date"
                        class="form-control ps-2 rounded-end"
                        :config="{
                          minDate   : scheduleData.startDate == null ? 'today' : scheduleData.startDate,
                          enableTime: true
                        }"
                  ></flat-pickr>
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
              </validation-provider>
            </b-col><!--end date-->

            <b-col sm="12" class="mb-1"><!--haveCapped-->
              <label class="form-label small fw-bold me-2"
                >Set Max Charge</label
              >
              <toggle-button
                class="m-0 me-2"
                v-model="scheduleData.haveCapped"
                color="#e73092"
                :sync="true"
              />
            </b-col><!--haveCapped-->

            <b-col sm="12" class="mb-1" v-if="scheduleData.haveCapped==1"><!--haveCapped-->
                <label class="form-label small fw-bold">Capped Amount<span class="text-danger">*</span></label>
                <validation-provider
                  name="Capped Amount"
                  :rules="{required:true,min_value:0}"
                  v-slot="{ errors, ariaMsg }"
                >
                  <div class="input-group"
                    :class="{
                      invalid: errors[0]
                    }">
                    <div class="input-group-text">₱</div>
                    <b-form-input
                      type="number"
                      class="form-control"
                      v-model="scheduleData.cappedAmount"
                      placeholder="0.00"
                      :class="{
                        invalid: errors[0]
                      }"
                    />
                  </div>
                  <b-form-invalid-feedback v-bind="ariaMsg">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </validation-provider>
            </b-col><!--haveCapped-->

            <b-col sm="12" class="mb-1" v-if="scheduleData.isActive!=orgStatus"><!--reason-->
              <validation-provider name="rateType" rules="required" v-slot="validationContext">
                <label>Reason<span class="text-danger">*</span></label>
                <b-form-group>
                  <b-form-select class="form-select rounded-0 rounded-start rounded-end shadow-none custom-select w-100" style="width:160px"
                    id="change-type"
                    v-model="scheduleData.reason"
                    :options="orgStatus ? lockReason : unlockReason"
                    :state="getValidationState(validationContext)"
                  ></b-form-select>
                </b-form-group>
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-col><!--reason-->

            <b-col sm="12" class="mt-2"><!--buttons-->
              <div class="text-end">
                <b-button
                  type="submit"
                  variant="primary"
                  class="me-2"
                >
                  <span v-if="mopDetailsForm?.hasSchedule">Setup</span>
                  <span v-else>Update Setup</span>
                </b-button>
                <b-button
                  type="button"
                  variant="light"
                  @click="closeModal('bv-modal-mop-setup')"
                >
                  Cancel
                </b-button>
              </div>
            </b-col><!--buttons-->
          </b-row>
        </b-form>
      </ValidationObserver>
    </b-modal>
  </div> <!-- end of outer div-->
</template>

<style>
 .invalid-feedback{
  display: block !important;
 }
</style>